type Props = { intensity?: number; seed?: number };

const PATHS = [
  'M -50 80 C 180 -10, 380 240, 620 80 S 1000 -40, 1340 160',
  'M -50 300 C 200 220, 400 480, 700 320 S 1100 240, 1340 380',
  'M -50 540 C 220 460, 460 700, 760 560 S 1100 480, 1340 620',
] as const;

const PIN_Y = [80, 300, 540] as const;
const PIN_Y2 = [160, 380, 620] as const;

export function RouteBg({ intensity = 0.35, seed = 0 }: Props) {
  const i = seed % 3;
  return (
    <svg
      className="route-bg"
      viewBox="0 0 1280 700"
      preserveAspectRatio="none"
      style={{ opacity: intensity }}
    >
      <path d={PATHS[i]} className="route-line" />
      <circle cx="60" cy={PIN_Y[i]} r="4" className="route-pin" />
      <circle cx="1240" cy={PIN_Y2[i]} r="4" className="route-pin" />
    </svg>
  );
}
